/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import SelectDropDown from '../../common/dropdown/SelectDropdown';
import { TInfo } from '../../types';

import { useGetBusinessSectorQuery } from '../../features/businessRegistration/businessRegistrationSlice';
import { decryptJson } from '../../utils/decryptJson';
import Button from '../../components/global/Button';
import '../../components/BusinessDashboard/BusinessRegistrationWrapper/businessRegistration.css';

type TProps = {
  step1: TInfo;
  setStep1: React.Dispatch<React.SetStateAction<TInfo>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
};
const AboutBusiness = ({ setStep, setStep1, step1, step }: TProps) => {
  const [disable, setDisabled] = useState(false);
  const [description, setDescription] = useState<boolean>();
  const token = localStorage.getItem('login-token');

  const { data } = useGetBusinessSectorQuery({ token });

  const sectors = decryptJson(data?.data);

  const [selectedBusinessSegment, setSelectedBusinessSegment] = useState({
    value: '',
    label: '',
  });
  const completedSteps: boolean[] = JSON.parse(localStorage.getItem('completed-steps1') ?? '[]');
  const updateCompletedSteps = () => {
    completedSteps[step - 1] = true;
    localStorage.setItem('completed-steps1', JSON.stringify(completedSteps));
  };

  const validateInputsResult = useMemo(() => {
    const isSelectedBusinessSegment = step1?.businessSegment ? step1.businessSegment !== '' : false;
    const isBusinessDescription = step1?.businessDesc?.length >= 80;
    setDescription(isBusinessDescription);

    return isSelectedBusinessSegment && isBusinessDescription;
  }, [step1.businessSegment, step1?.businessDesc]);

  useEffect(() => {
    setStep1({
      ...step1,
      structureOfBusiness: 'Incorporated Trustees',
    });
  }, []);

  useEffect(() => {
    if (validateInputsResult) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [validateInputsResult]);

  const sectorsData = [
    { label: 'Religious body', value: 'Religious body' },
    { label: 'Social clubs', value: 'Social clubs' },
    { label: 'Associations and Alumnis', value: 'Associations and Alumnis' },
    { label: 'Non Governmental Organization(NGO)', value: 'Non Governmental Organization(NGO)' },
  ];

  return (
    <div className='stepOneContainer flex w-full sl:w-[700px] '>
      <form className='w-full formCont sl:px-[4px] '>
        <div className='w-full'>
          {/* <div className='font-Poppins font-medium text-[28px] leading-[42px] m-4 !mb-6 !ml-0'>Lets get your business registered!</div> */}

          <div className='sl:flex justify-between'>
            <div className='w-full  text-xs mb-[27px] '>
              <SelectDropDown
                className='border-[1px] border-[#DDDDDD] rounded-[2px] !h-[52px] focus:border-[#F8B400]'
                label='What type of Non-profit organization(NPO) do you want to register?'
                labelStyles='text-[#212121] text-[13px] font-poppins font-normal leading-[18px] pb-[5px] '
                options={
                  sectorsData &&
                  sectorsData?.map((item: any) => {
                    return {
                      label: item.label,
                      value: item.value,
                    };
                  })
                }
                width='w-[100%]'
                setSelectedOption={setSelectedBusinessSegment}
                onChange={() => {
                  setStep1({
                    ...step1,
                    businessSegment: selectedBusinessSegment.label,
                  });
                }}
                value={step1?.businessSegment}
              />
            </div>
          </div>
          <div className='mb-[27px] '>
            <label htmlFor='describeBusiness'>State the objectives of the organization</label>
            {!description && (
              <span className=' ml-9 text-errorRed font-Poppins  text-[10px]'>
                (minimum 80 characters)
              </span>
            )}
            <div className='w-full  rounded-[5px] outline-none border-[1px] border-[#DDDDDD] focus:border-[#f8b400]'>
              <textarea
                id='describeBusiness'
                className='w-full outline-none resize-none text-sm text-[#768396] py-3 px-3 focus:border-[#F8B400]'
                placeholder='minimum 80 characters'
                // name='describeBusiness'
                value={step1?.businessDesc}
                onChange={(e) => {
                  setStep1({ ...step1, businessDesc: e.target.value });
                }}
                minLength={80}
              />
            </div>
            <div style={{ color: 'rgba(2, 135, 137, 1)', fontSize: '12px' }}>
              Minimum: 80 Characters
            </div>
          </div>

          <div className='w-full sl:flex sl:justify-between mt-[40px] sl:items-end'>
            <div className='mb-[27px] w-full'>
              {/* <div className='mb-[27px]'> */}
              <label className='flex flex-col relative pb-2 text-[#212121] '>
                Organization Structure
              </label>
              <input
                style={{ backgroundColor: 'rgba(221, 221, 221, 1)' }}
                className='w-full  h-[52px] px-2 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none sl:text-[15px] text-xs'
                value={step1?.structureOfBusiness}
                readOnly
              />
              {/* </div> */}
            </div>
          </div>
          <div className='mb-7 items-center flex justify-between mt-8 sl:max-w-full'>
            <Button
              theme='primary'
              className='!px-[52px] py-[10px] font-medium text-[13px] bg-[#768396] text-white inline-block '
              size='sm'
              underline={false}
              tag='a'
              href='/my-business'
            >
              CANCEL
            </Button>
            <Button
              disabled={disable}
              theme='primary'
              className='px-[23px] font-medium py-[10px] text-[13px] inline-block '
              size='sm'
              underline={false}
              onClick={() => {
                setStep((currPage) => currPage + 1);
                updateCompletedSteps();
              }}
              type='submit'
            >
              SAVE AND CONTINUE
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AboutBusiness;
